import React, { useEffect, useState } from "react";
import { Box, Typography, CardMedia, CardActions, useTheme } from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import ImagenNotFound from "../images/Imagen_not_found.png";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { imgPath } from "../helpers/imgPath";

const ArticuloItem = ({
  item,
  isBarcode,
  tieneObs = false,
  onClickImg,
  onIncrease,
  onDecrease,
  onEdit,
  onDelete,
  dynamicColor, // Nuevo prop para el color dinámico
}) => {
  const theme = useTheme();

  // Función para obtener el color a usar
  const getColorToUse = () => {
    return dynamicColor || theme.bandera.colorSecundario;
  };

  const idProducto = item.idArticulo;
  const codigo = item.codigo;
  const descripcion = item.descripcion;
  const precio = item.precioUnitario;
  const imageSource = item.imagen;
  console.log(item.imagen);

  const [quantity, setQuantity] = useState(item.cantidadArticulo);

  // Sincronizar el estado local con las props cuando cambie item.cantidadArticulo
  useEffect(() => {
    setQuantity(item.cantidadArticulo);
  }, [item.cantidadArticulo]);

  const noSelectStyle = {
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
  };

  const handleIncrease = () => {
    if ((item && item.comandaDetalleElementos.length === 0) || isBarcode) {
      const nuevaCantidad = quantity + 1;
      setQuantity(nuevaCantidad);
      onIncrease(nuevaCantidad);
    } else {
      onIncrease(quantity);
    }
  };

  const handleDecrease = () => {
    if (quantity > 0) {
      const nuevaCantidad = quantity - 1;
      setQuantity(nuevaCantidad);
      onDecrease(nuevaCantidad);
    }
  };

  const handleDelete = () => {
    onDelete();
    setQuantity(0);
  };

  const getColorByEstadoLocacion = estado => {
    switch (estado) {
      case 0:
        return "#FFE4B5";
      case 1:
        return "#ADD8E6";
      case 2:
        return "#90EE90";
      case -1:
        return "#FFB6C1";
      default:
        return "#FFFFFF";
    }
  };
  const estado = item?.pedidosProductosALocacion?.estado || undefined;
  const stripeColor = getColorByEstadoLocacion(estado);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#FFFFFF",
        borderRadius: "4px",
        p: 1,
        margin: 1,
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        borderRight: `10px solid ${stripeColor}`,
        ...noSelectStyle,
      }}
    >
      <CardActions sx={{ p: 0, flex: 1 }}>
        <CardMedia
          onClick={event => {
            event.stopPropagation();
            onClickImg(imageSource, descripcion);
          }}
          key={idProducto}
          component="img"
          image={imageSource || ImagenNotFound}
          sx={{ width: 50, height: 50, borderRadius: "8px", mr: 0, ml: 0 }}
        />
        <Box sx={{ flex: 1, ml: 1 }}>
          <Typography fontSize={8} fontWeight="bold">
            Cód. {codigo}
          </Typography>
          <Typography fontSize={8} color="textSecondary">
            {descripcion.length > 15 ? (
              <>
                {descripcion.slice(0, 14)}
                <br />
                {descripcion.slice(14)}
              </>
            ) : (
              descripcion
            )}
          </Typography>
          {/* Mostrar descripcionPersonalizada si existe, sino mostrar comentarios */}
          {/* {item && (item.descripcionPersonalizada || item.comentarios) && (
            <Typography fontSize={10} color="textSecondary">
              Obs. {item.descripcionPersonalizada || item.comentarios}
            </Typography>
          )} */}
        </Box>
        <Box sx={{ textAlign: "right", mr: 2 }}>
          <Typography fontSize={10} sx={{ fontWeight: "bold", fontSize: 10 }}>
            {quantity <= 1 ? `$${precio.toLocaleString("es-Ar")}` : `$${(precio * quantity).toLocaleString("es-Ar")}`}
          </Typography>
          {item && item.descuentoImporte > 0 && (
            <Typography fontSize={10} color="textSecondary">
              {item.descuentoImporte}
            </Typography>
          )}
        </Box>
      </CardActions>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <RemoveCircleIcon sx={{ fontSize: 20, color: quantity === 0 ? "darkgray" : getColorToUse() }} onClick={handleDecrease} disabled={quantity === 0} />
        <Typography fontSize={10} sx={{ mx: 1 }}>
          {quantity}
        </Typography>
        <AddCircleIcon sx={{ fontSize: 20, mr: 1, color: getColorToUse() }} onClick={handleIncrease} />
        <EditIcon
          sx={{ fontSize: 20, mr: 1, color: quantity !== 0 ? (tieneObs ? getColorToUse() : "#7d7d7d") : "darkgray" }}
          onClick={() => {
            quantity !== 0 && onEdit();
          }}
          disabled={quantity === 0}
        />
        {/* <CopyrightIcon sx={{ fontSize: 18, mr: -1.5, color: getColorToUse()  }} onClick={handleDelete}/> */}
      </Box>
    </Box>
  );
};

export default ArticuloItem;
